import React, { useEffect, useState } from 'react';
import { Row, Col, message } from 'antd';
import C3Select from './C3Select';
import ShopStore from 'stores/ShopStore';
import { webServiceProvider } from 'shared';

const C3container = ({
  itemKey,
  diagnosis = {},
  deleteSubItem,
  changeItemProperty,
}) => {
  const shopId = ShopStore.currentShop.id;

  const [items, setItems] = useState({});

  const handleAction = (action) => (value, type) => {
    if (action === 'Deleted') value = null;
    changeItemProperty(itemKey, 'diagnosis', {
      ...diagnosis,
      [`${type}Id`]: value,
    });
  };

  const selectTypes = ['complaint', 'cause', 'correction'];

  const fetchOptions = async () => {
    try {
      const queryParams = new URLSearchParams();
      queryParams.set('shop_id', shopId); // Replace with the actual shop ID', sys);
      const response = await webServiceProvider.get(
        `v1/vmrs-diagnosis?${queryParams.toString()}`
      );

      if (response[0]?.result) {
        const { complaint, cause, correction } = response[0].result;

        setItems({ complaint, cause, correction });
      }
    } catch (error) {
      message.error('Failed to fetch service options');
    }
  };

  useEffect(() => {
    fetchOptions();
  }, []);

  useEffect(() => {
    fetchOptions();
  }, [shopId]);

  return (
    <Row style={{ margin: '10px' }} gutter={16}>
      {selectTypes.map((type) => (
        <Col key={type} span={8}>
          <C3Select
            title={`${type.charAt(0).toUpperCase() + type.slice(1)}:`}
            type={type}
            handleSelect={handleAction('Selected')}
            handleAdd={handleAction('Added')}
            handleDelete={handleAction('Deleted')}
            value={diagnosis?.[`${type}Id`] || ''}
            shopId={shopId}
            items={items?.[type] || []}
          />
        </Col>
      ))}
    </Row>
  );
};

export default C3container;
